import { getTargetCount } from "../../../utils/archeryConfig.js";
import {
  formatRoundTime,
} from "../../../utils/dateUtils.js";
import TimeLabel from "../../../components/TimeLabel/TimeLabel.js";
import styles from "./ProgressTable.module.css";

const ProgressTable = ({ event, date, data }) => {
  const targetCount = getTargetCount(date, event);
  const is145M = event === "145";

  // 상태별 색상과 텍스트 매핑
  const statusConfig = {
    progress: { dot: styles.red, text: "경기 진행 중" },
    waiting: { dot: styles.blue, text: "경기 대기 중" },
    entrance: { dot: styles.green, text: "경기장 내 입장" },
  };

  return (
    <>
      {data.map((schedule, scheduleIndex) => {
        const status = statusConfig[schedule.status];

        // 각 과녁의 최대 선수 수 계산
        const maxPlayersPerTarget = Math.max(
          ...schedule.players.map((targetPlayers) => targetPlayers.length),
          0
        );

        // 각 과녁을 group1, group2로 나누기 위한 중간 지점
        const playersPerGroup = Math.ceil(maxPlayersPerTarget / 2);

        return (
          <div
            key={scheduleIndex}
            className={`table-box ${is145M ? "box-3" : "box-1"}`}
          >
            <div className="table-title">
              <TimeLabel time={formatRoundTime(schedule.time)} />
            </div>
            <div className={styles.tableStatus}>
              <span className={`${styles.dot} ${status.dot}`}></span>
              {status.text} ({schedule.group1}조/{schedule.group2}조)
            </div>
            <table className={is145M ? "text-center" : ""}>
              <thead>
                <tr>
                  {[...Array(targetCount)].map((_, i) => (
                    <th key={i}>{i + 1}T</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* group1 */}
                {[...Array(playersPerGroup)].map((_, rowIndex) => (
                  <tr
                    key={`group1-${rowIndex}`}
                    className={
                      rowIndex === playersPerGroup - 1 ? "border-bt" : ""
                    }
                  >
                    {[...Array(targetCount)].map((_, colIndex) => {
                      const targetPlayers = schedule.players[colIndex] || [];
                      const playerName = targetPlayers[rowIndex];
                      return <td key={colIndex}>{playerName || ""}</td>;
                    })}
                  </tr>
                ))}

                {/* group2 */}
                {[...Array(playersPerGroup)].map((_, rowIndex) => (
                  <tr key={`group2-${rowIndex}`}>
                    {[...Array(targetCount)].map((_, colIndex) => {
                      const targetPlayers = schedule.players[colIndex] || [];
                      const playerName =
                        targetPlayers[rowIndex + playersPerGroup];
                      return <td key={colIndex}>{playerName || ""}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </>
  );
};
export default ProgressTable;
